import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { ApiConfig } from '@/config/api.config';
import { UrlHelper } from '@/utils/UrlHelper';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';
import { useReleasesFilter } from '@/features/releases/store/useReleasesFilter';
import { AppReleaseListResponseDto } from '@/features/releases/types/releases-dto';

export const useReleasesListApi = () => {
    const axiosInstance = useAxiosAuth();

    const { filter } = useReleasesFilter();
    const { take, skip, searchText } = filter;

    const {
        data: releasesListData,
        isLoading: isLoadingReleasesListData,
        isError: isErrorReleasesListData,
    } = useQuery({
        queryKey: [ApiConfig.queries.features.releases.queryKeys.list, take, skip, searchText],
        queryFn: async (): Promise<AppReleaseListResponseDto> => {
            const url = UrlHelper.buildUrlWithQueryParams(
                ApiConfig.queries.features.releases.endpoints.list,
                {
                    take,
                    skip,
                    searchText,
                },
            );
            const response = await axiosInstance.get<AppReleaseListResponseDto>(url);
            return response.data;
        },
        placeholderData: keepPreviousData,
    });

    return {
        releasesListData,
        isLoadingReleasesListData,
        isErrorReleasesListData,
    };
};
